import { handleResponse, handleError } from "./apiUtils.js";
import { generateClient } from 'aws-amplify/api';

import * as queries from '../graphql/queries.js';
import * as mutations from '../graphql/mutations.js';

import demoParams from '../__test__/demoParams.js';
import _ from 'underscore';

export const FETCH_BRANCHES_BY_COMPANY_ID_SUCCESS = "FETCH_BRANCHES_BY_COMPANY_ID_SUCCESS";
export const FETCH_DIVISIONS_BY_BRANCH_ID_SUCCESS = "FETCH_DEPARTMENTS_BY_BRANCH_ID_SUCCESS"
export const FETCH_DEPARTMENTS_BY_COMPANY_ID_BRANCH_ID_DIVISION_ID_SUCCESS = "FETCH_DEPARTMENTS_BY_COMPANY_ID_BRANCH_ID_DIVISION_ID_SUCCESS";
export const FETCH_RESOURCE_COLLECTIONS_BY_USER_ID_GENERAL_ID_COMPANY_ID_SUCCESS = "FETCH_RESOURCE_COLLECTIONS_BY_USER_ID_GENERAL_ID_COMPANY_ID_SUCCESS";
export const FETCH_TOUR_APPROVALS_SUCCESS = "FETCH_TOUR_APPROVALS_SUCCESS";
export const FETCH_TIME_KEEPER_REVERSALS_BY_RESOURCE_DAY_TYPE_ID = "FETCH_TIME_KEEPER_REVERSALS_BY_RESOURCE_DAY_TYPE_ID";

const client = generateClient();

export async function getBranchesByCompanyId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await client.graphql(
    {
      query: queries.approvalsApIgetBranchesByCompanyId,
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.approvalsAPIgetBranchesByCompanyId;
}

export async function getDivisionsByBranchId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await client.graphql(
    {
      query: queries.approvalsApIgetDivisionsByBranchId,
      variables: parameters
    }
  )
  .catch(handleError);

  return response.data.approvalsAPIgetDivisionsByBranchId;
}

export async function getDepartmentsByCompanyIdBranchIdDivisionId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await client.graphql(
    {
      query: queries.approvalsApIgetDepartmentsByCompanyIdBranchIdDivisionId,
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.approvalsAPIgetDepartmentsByCompanyIdBranchIdDivisionId;
}

export async function getResourceCollectionsByUserIdGeneralIdCompanyId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await client.graphql(
    {
      query: queries.approvalsApIgetResourceCollectionsByUserIdGeneralIdCompanyId, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.approvalsAPIgetResourceCollectionsByUserIdGeneralIdCompanyId;
}

export async function getTourApprovals(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await client.graphql(
    {
      query: queries.approvalsApIgetTourApprovals, 
      variables: parameters
    }
  )
    .catch(handleError);
  return response.data.approvalsAPIgetTourApprovals;
}

export async function getTimeKeeperReversalsByResourceDayTypeId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await client.graphql(
    {
      query: queries.approvalsApIgetTimeKeeperReversalCheckByTourId, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.approvalsAPIgetTimeKeeperReversalCheckByTourId;
}

export async function getTourIsDirectBillingCheckByTourId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await client.graphql(
    {
      query: queries.approvalsApIgetTourIsDirectBillingCheckByTourId, 
      variables: parameters
    }
  )
    .catch(handleError);
  return response.data.approvalsAPIgetTourIsDirectBillingCheckByTourId;
}

export async function getContactInfoByTourId(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await client.graphql(
    {
      query: queries.approvalsApIgetContactInfoCheckByTourId, 
      variables: parameters
    }
  )
    .catch(handleError);
  return response.data.approvalsAPIgetContactInfoCheckByTourId;
}

export async function createTimeKeeperReversal(parameters) {

  parameters.ipAddress = '27.0.0.1';

  let response = await client.graphql(
    {
      query: mutations.approvalsApIcreateTimeKeeperReversal, 
      variables:parameters
    }
  )
    .catch(handleError);
  return response.data.approvalsAPIcreateTimeKeeperReversal;
}

export async function updateTourApprovals(parameters) {
  
  parameters.ipAddress = '27.0.0.1';
  
  let response = await client.graphql(
    {
      query: mutations.approvalsApIupdateTourApprovals, 
      variables: parameters
    }
  )
    .catch(handleError);
  return response.data.approvalsAPIgetTourApprovals;
}
